import React, { useMemo, useState } from 'react';
import { CheckCircle2, CircleAlert } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function AllergenSelector({ allergens = [], selected = [], verified = false, onChange, compact = false, dense = false }) {
  const [search, setSearch] = useState('');
  const rows = useMemo(
    () => allergens.filter(a => String(a.name || '').toLowerCase().includes(search.toLowerCase())),
    [allergens, search]
  );

  const commit = next => onChange?.(next, true);
  const toggle = name => commit(selected.includes(name) ? selected.filter(a => a !== name) : [...selected, name]);
  const noneSelected = selected.length === 0 && verified;

  return <div className={`rounded-lg border p-3 ${dense ? 'flex h-full min-h-0 flex-col overflow-hidden' : ''} ${verified ? 'bg-slate-50/70' : 'border-amber-300 bg-amber-50/40'}`}>
    <div className="mb-2 flex shrink-0 items-start justify-between gap-2">
      <div className="min-w-0">
        <Label>Allergeni dichiarati *</Label>
        <p className={`mt-0.5 flex items-center gap-1 text-xs ${verified ? 'text-green-700' : 'text-amber-700'}`}>
          {verified ? <CheckCircle2 className="h-3.5 w-3.5 shrink-0"/> : <CircleAlert className="h-3.5 w-3.5 shrink-0"/>}
          <span>{verified ? (selected.length ? `${selected.length} allergeni selezionati · verificati` : 'Nessun allergene dichiarato · verificato') : 'Allergeni da verificare'}</span>
        </p>
      </div>
      {dense
        ? <Button type="button" variant={noneSelected ? 'default' : 'outline'} className="h-9 min-h-9 shrink-0 px-3 text-xs" onClick={() => commit([])} aria-label="Nessun allergene dichiarato">Nessun allergene</Button>
        : !compact && <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Cerca allergene" className="max-w-[220px] min-h-11"/>}
    </div>

    {compact && !dense && <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Cerca allergene" className="min-h-11 mb-2"/>}

    <div className={`grid ${dense ? 'min-h-0 flex-1 auto-rows-min grid-cols-2 content-start gap-1.5 overflow-y-auto overscroll-contain touch-pan-y pr-1 pb-1 sm:grid-cols-3 lg:grid-cols-4' : compact ? 'grid-cols-1 sm:grid-cols-2 gap-2 max-h-48 overflow-y-auto' : 'sm:grid-cols-2 gap-2 max-h-48 overflow-y-auto'}`}>
      {rows.map(a => <button type="button" key={a.allergen_id || a.name} onClick={() => toggle(a.name)} aria-pressed={selected.includes(a.name)} className={`${dense ? 'min-h-9 px-2 py-1.5 text-xs' : 'min-h-11 md:min-h-12 px-3 py-2 text-sm'} rounded-lg border text-left transition-colors inline-flex items-center gap-2 ${selected.includes(a.name) ? 'border-amber-300 bg-amber-50 text-amber-900' : 'bg-white hover:bg-slate-50'}`}>
        {selected.includes(a.name) && <CheckCircle2 className="h-4 w-4 shrink-0"/>}{a.name}
      </button>)}
    </div>

    {!dense && <div className="mt-3 flex shrink-0 flex-wrap gap-2">
      <Button type="button" variant={noneSelected ? 'default' : 'outline'} className="min-h-11" onClick={() => commit([])}>Nessun allergene dichiarato</Button>
      {selected.length > 0 && !verified && <Button type="button" className="min-h-11" onClick={() => commit(selected)}>Conferma selezione</Button>}
    </div>}
    {dense && selected.length > 0 && !verified && <div className="mt-2 flex shrink-0 justify-end"><Button type="button" className="h-9 min-h-9 text-xs" onClick={() => commit(selected)}>Conferma selezione</Button></div>}
  </div>;
}
